<template>
  <div class="pa-connection-pod-selector-modals">
    <PaOverlayModal
     :isOpen="isModalOpen"
     :isFreez="isModalFreez"
     :additionalZIndex="1"
     :appendClass="['pa-overlay-modal-default-transition', 'pa-connection-pod-selector-modal']"
     :position="{top: .15}"
     contentTransitionName="trans-content"

     @beforeEnterContent="handleBeforeEnterContent"
     @afterEnterContent="handleAfterEnterContent"
     @closeOverlayModal="handleCloseOverlayModal"
     @afterLeaveContent="handleAfterLeaveContent"
    >
      <div class="pa-connection-pod-selector" ref="mainbox">
        <ConnectionManageModalHeader ref="header" />

        <div class="pa-content-field" ref="contentField">
          <transition name="pa-simple-fade">
            <ConnectionManageModalCreatePod
             v-if="(viewType === 'create')"
             :isLoading="isLoadingCreateAction"
             @submitButton="handleClickSubmitCreateButton"
             @clickCancel="handleClickCancelCreateButton"
            />
          </transition>

          <transition name="pa-simple-fade">
            <ConnectionManageModalPodList
             v-if="(viewType === 'list') && (roomListLength !== 0)"
             :contentFieldHeight="contentFieldHeight"
             @selectPodRoom="handleSelectPodRoom"
            />
          </transition>
          
          <transition name="pa-simple-fade">
            <ConnectionManageModalLoading
             v-if="(viewType === 'loading')"
             :viewType="loadingViewType"
            />
          </transition>
          
          <transition name="pa-simple-fade">
            <ConnectionManageModalNoPodView
             v-if="(viewType === 'list') && (roomListLength === 0)"
            />
          </transition>
        </div>

        <ConnectionManageModalActionButton
         ref="actions"
         :isDisabled="isDisabledCreateButton"
         @clickSubmit="handleClickCreateButton"
         @clickCancel="handleClickCancelButton"
        />
      </div>
    </PaOverlayModal>

    <!-- 選択したPodRoomへキャラクター追加の確認モーダル -->
    <ConnectionManageAddCharacterConfirmModal
     @clickSubmit="handleClickSubmitAddCharacterConfirmModal"
    />
  </div>
</template>

<script>
import {GetPodRoomList} from '@/graphql/queries/ConnectionPod.graphql'

import PaOverlayModal from '@/components/Parts/PAOverlayModal/PAOverlayModal.vue'

import ConnectionManageModalHeader        from '@/components/Parts/PAConnectionManageModal/Parts/ConnectionManageModalHeader.vue'
import ConnectionManageModalLoading       from '@/components/Parts/PAConnectionManageModal/Parts/ConnectionManageModalLoading.vue'
import ConnectionManageModalNoPodView     from '@/components/Parts/PAConnectionManageModal/Parts/ConnectionManageModalNoPodView.vue'
import ConnectionManageModalCreatePod     from '@/components/Parts/PAConnectionManageModal/Parts/ConnectionManageModalCreatePod.vue'
import ConnectionManageModalPodList       from '@/components/Parts/PAConnectionManageModal/Parts/ConnectionManageModalPodList.vue'
import ConnectionManageModalActionButton  from '@/components/Parts/PAConnectionManageModal/Parts/ConnectionManageModalActionButton.vue'

import ConnectionManageAddCharacterConfirmModal from '@/components/Parts/PAConnectionManageModal/Parts/ConnectionManageAddCharacterConfirmModal.vue'

import StoryItemUseModalMixin     from '@/mixins/StoryItemUseModalMixin.js'
import ConnectionManageCreatePodMixins    from '@/components/Parts/PAConnectionManageModal/Mixins/ConnectionManageCreatePodMixins.js'
import ConnectionManageAddCharacterMixins from '@/components/Parts/PAConnectionManageModal/Mixins/ConnectionManageAddCharacterMixins.js'

export default {
  mixins      : [
    StoryItemUseModalMixin,
    ConnectionManageCreatePodMixins,
    ConnectionManageAddCharacterMixins
  ],

  components  : {
    PaOverlayModal,
    ConnectionManageModalHeader,
    ConnectionManageModalLoading,
    ConnectionManageModalNoPodView,
    ConnectionManageModalCreatePod,
    ConnectionManageModalPodList,
    ConnectionManageModalActionButton,

    ConnectionManageAddCharacterConfirmModal
  },

  data(){
    return {
      isModalFreez            : false,

      viewType                : 'list',

      loadingViewType         : 'loading',

      isDisabledCreateButton  : false,

      contentFieldHeight      : null,
    };
  },

  computed : {
    isModalOpen(){
      return this.$store.state.connectionManageModal.isModalOpen;
    },

    podRoomType(){
      return 'private';
    },

    roomListLength(){
      if(typeof this.joinedPodRoomList === 'undefined'){
        return 0;
      }else{
        return this.joinedPodRoomList.length;
      }
    }
  },

  apollo : {
    joinedPodRoomList : {
      query : GetPodRoomList,
      variables(){
        return {
          roomType  : this.podRoomType
        };
      }
    }
  },

  watch : {
    contentFieldHeight : {
      handler(value){
        if(typeof value === 'undefined') return;
        if(value === null) return;
        
        this.$refs.contentField.style.height = value+'px';
      },
      immediate: true
    }
  },

  methods : {
    closeModal(){
      this.$store.dispatch({
        type  : 'connectionManageModal/updateConnectionManageModal',
        value : false,
      });
    },

    calcHeight(){
      const boxHeight     = this.$refs.mainbox.clientHeight;
      const headerHeight  = this.$refs.header.offsetHeight();
      const actionsHeight = this.$refs.actions.offsetHeight();
      const diffHeight    = boxHeight - (headerHeight + actionsHeight + 38);

      this.contentFieldHeight = diffHeight;
    },

    handleBeforeEnterContent(){
      this.$apollo.queries.joinedPodRoomList.refetch();
    },

    handleAfterEnterContent(){
      this.calcHeight();
    },

    handleCloseOverlayModal(){
      this.closeModal();
    },

    handleAfterLeaveContent(){
      this.contentFieldHeight = null;
    },

    handleClickCreateButton(){
      this.viewType = 'create';
    },

    handleClickCancelButton(){
      this.closeModal();
    },

    handleSelectPodRoom(podRoom){
      this.$store.dispatch({
        type    : 'connectionManageModal/updateCharacterConfirmModal',
        value   : true,
        podRoom : podRoom
      });
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";

.pa-layout.pa-overlay-modal.pa-connection-pod-selector-modal{
  .pa-connection-pod-selector{
    width:100vw;
    height:70vh;
    background-color: #CAB090;
    border-top:5px solid #89620C;
    border-bottom:5px solid #89620C;

    @include until($tablet) {
      width:100vw;
    }

    @include from($tablet) {
      max-width:600px;
      margin:0 auto;
      border-left:5px solid #89620C;
      border-right:5px solid #89620C;
      border-radius: 5px 5px 0 0;
    }

    .pa-content-field{
      width:98%;
      margin:0 auto .5rem;
      position: relative;
      height:auto;
      overflow: hidden;
    }
  }
}
</style>